
export class OffsetInfo {
    hours: number;
    mins: number;
    negative: boolean;

    constructor(value?: Partial<OffsetInfo>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class Timezone {
    description: string;
    id: string;
    offsetInfo: OffsetInfo;

    constructor(value?: Partial<Timezone>) {
        if (value) {
            if (value.offsetInfo) {
                value.offsetInfo = new OffsetInfo(value.offsetInfo);
            }
            if (value.description && value.description !== 'Other...') {
                value.description = value.description + ' (' + value.id + ')';
            }
            Object.assign(this, value);
        }
    }
}
